<template>
  <Reloj />
</template>

<script>
// @ is an alias to /src
import Reloj from "@/components/Reloj.vue";

export default {
  name: "Home",
  components: {
    Reloj,
  },
};
</script>

<style lang="scss" scoped>
</style>
